/**
 * There will be one reducer file per page / common component
 */
 import {
    GET_CATEGORY_NAME,
    TEMPLATE_FLAG
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';

const initialState = {
    loading: false,
    categoryName:'',
    moreTemplate:false
};

const CategoryNameReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CATEGORY_NAME:
            return {
                ...state,
                loading: true,
                categoryName: action.payload,
            };
        case TEMPLATE_FLAG:
            return {
                ...state,
                loading: true,
                moreTemplate: action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

export default CategoryNameReducer;
